import { render } from "./productCatlog.vue?vue&type=template&id=c0138ddc&scoped=true"
import script from "./productCatlog.vue?vue&type=script&lang=js"
export * from "./productCatlog.vue?vue&type=script&lang=js"

import "./productCatlog.vue?vue&type=style&index=0&id=c0138ddc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Midea\\Desktop\\产品管理系统\\ProductManager\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0138ddc"]])

export default __exports__